import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { getUpdatedNavigation } from 'app/store/fuse/navigationSlice';
import { Button } from '@mui/material';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import { userContext } from '../layout1/Layout1';

const Root = styled('div')(({ theme }) => ({
  '& .username, & .email': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },

  '& .avatar': {
    background: theme.palette.background.default,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    bottom: 0,
    '& > img': {
      borderRadius: '50%',
    },
  },
}));

function UserNavbarHeader(props) {
  const user = useSelector(selectUser);
  const [displayName, setDisplayName] = useState();
  const [profileImageUrl, setProfileImageUrl] = useState();
  const [userDetail , setUserDetail] = useContext(userContext)
  const [email, setEmail] = useState();
  const token =localStorage.getItem('token');
  const dispatch = useDispatch();
  const usersImg = async () => {
    const token = jwtDecode(localStorage.getItem('token'));
    const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${token.email}`;
    const result = await OAuthService.getList(url);
    const users = result?.data;
    if (users.profileImage) {
      const response = await OAuthService.getDownload(`${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/image/download/${users.profileImage}`);
      const imgURL = URL.createObjectURL(response.data)
      setProfileImageUrl(imgURL)
    }else{
      setProfileImageUrl('')
    }
  }
  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = jwtDecode(localStorage.getItem('token'));
      setDisplayName(token.name);
      setEmail(token.email);
      // usersImg();
    }
  }, [token, userDetail])

  useEffect(() => {
    // if (user) {
      setTimeout(() => {
        dispatch(getUpdatedNavigation())
      }, 800)
    // }
  }, [user,token, userDetail])

  return (
    <Root className="user relative flex flex-col items-center justify-center p-16 pb-14 shadow-0">
      <div className="flex items-center justify-center mb-24">
      { profileImageUrl  ? <Avatar
          sx={{
            backgroundColor: 'background.paper',
            color: 'text.secondary',
          }}
          className="avatar text-32 font-bold w-96 h-96"
          src={profileImageUrl}
          alt={user.data.displayName}
        >
          {user.data.displayName.charAt(0)}
        </Avatar>: (
          <Avatar className="md:mx-4" sx={{ width: 96, height: 96 }}>{displayName && displayName.charAt(0)}</Avatar>
        )}
      </div>
      <Typography className="username text-14 whitespace-nowrap font-medium">
        {displayName}
      </Typography>
      <Typography className="email text-13 whitespace-nowrap font-medium" color="text.secondary">
        {email}
      </Typography>
      {/*<Button onClick={() => dispatch(getUpdatedNavigation())}>TEST</Button>*/}
    </Root>
  );
}

export default UserNavbarHeader;
